var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{ 'MonthCapacityStatus--danger': _vm.isRejectStatus }},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._v(" "+_vm._s(_vm.getStatusName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }